import React from 'react';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';

const legendItems = {
  [reportingCopy.educationLevels[1]]:
    reportingCopy.topChosen.outOfHsColorScale[0],
  [reportingCopy.educationLevels[2]]:
    reportingCopy.topChosen.outOfHsColorScale[1],
  [reportingCopy.educationLevels[3]]:
    reportingCopy.topChosen.outOfHsColorScale[2],
  [reportingCopy.educationLevels[4]]:
    reportingCopy.topChosen.outOfHsColorScale[3],
  [reportingCopy.educationLevels[5]]:
    reportingCopy.topChosen.outOfHsColorScale[4],
  [reportingCopy.educationLevels[6]]:
    reportingCopy.topChosen.outOfHsColorScale[5],
  [reportingCopy.educationLevels[7]]:
    reportingCopy.topChosen.outOfHsColorScale[6],
  [reportingCopy.educationLevels[8]]:
    reportingCopy.topChosen.outOfHsColorScale[7],
};

export default function LevelOfEducationLegend() {
  return (
    <div className="level-of-education-legend">
      {Object.entries(legendItems).map((item) => {
        return (
          <div className="level-of-education-legend__item" key={item[0]}>
            <div
              className="level-of-education-legend__color-square"
              style={{
                backgroundColor: item[1],
              }}
            />
            <div className="level-of-education-legend__label">{item[0]}</div>
          </div>
        );
      })}
    </div>
  );
}
